import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../../components";
import { device } from "../../../../../services";
import { FiltersDropdownWrapper } from "../../../../../components/DateRangeFiltersInput/styled";
import { DropdownOptionsList } from "../../../../../components/DropdownOptions/styled";

export const FilterSectionsWrapper = styled(WrapperContainer)`
  display: grid;
  grid-template-columns: repeat(3, minmax(298px, 420px));

  @media screen and ${device.laptop} {
    grid-template-columns: repeat(1, minmax(298px, 420px));
  }

  width: 100%;
  justify-content: center;

  ${FiltersDropdownWrapper} {
    width: 100% !important;

    ${DropdownOptionsList} {
      transform-origin: top center;
      top: unset !important;
      margin-left: unset;
    }
  }
`;

export const FilterSection = styled(WrapperContainer)`
  height: 100%;
  max-height: 380px;

  min-width: 298px;
  max-width: 420px;

  width: 100%;

  padding: 20px 24px 24px 34px;

  align-items: start;
  justify-content: flex-start;
`;

export const FilterSectionTitle = styled(Paragraph2)`
  font-weight: 700;
`;

export const Filter = styled(WrapperContainer)`
  padding-top: 24px;
  width: 100%;
`;
